<template>
  <BOverlay
    id="scroll"
    :show="loading"
    spinner-variant="primary"
    variant="light"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <div
      id="table"
      style="height: calc(100vh - 300px); overflow-y: scroll;"
      @scroll="handleScroll"
    >
      <BTable
        :items="items"
        :fields="fields"
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        show-empty
        class="align-middle mb-0 bordered-body-b-table"
      >
        <!-- Nama Karyawan -->
        <template #cell(name)="data">
          <div class="flex items-center justify-start gap-[.75rem]">
            <img
              :src="data.item.photo_profile_url || 'https://storage.googleapis.com/komerce/assets/avatars/image-null.png'"
              alt="User Profile"
              class="aspect-ratio--1x1 rounded-lg size-[45px] object-cover"
            >
            <div class="flex flex-col">
              <span class="text-[14px] font-semibold text-[#0F172A] leading-tight mb-0.5">
                {{ data.item.name }}
              </span>
              <span class="text-[12px] text-[#94A3B8] leading-tight">
                {{ data.item.role }}{{ data.item.division ? ` • ${data.item.division}` : '' }}
              </span>
            </div>
          </div>
        </template>

        <!-- Tanggal Lembur -->
        <template #cell(date)="data">
          <span class="text-[14px] text-[#334155] font-medium">
            {{ data.item.date }}
          </span>
        </template>

        <!-- Durasi Lembur -->
        <template #cell(duration)="data">
          <span class="text-[14px] text-[#334155] font-medium">
            {{ data.item.duration }}
          </span>
        </template>

        <!-- Status Approval -->
        <template #cell(status)="data">
          <div class="flex items-center">
            <div
              v-for="(badge, bIdx) in data.item.approvalChain"
              :key="bIdx"
              class="size-7 rounded-xl flex items-center justify-center transition-all !border-white !border-[2px] p-[.25rem]"
              :class="`${badgeClasses(badge)}${bIdx > 0 ? ' translate-x-[-5px]' : ''}`"
            >
              <span
                v-if="badge === 'pending'"
                class="k-timer text-[14px]"
              />
              <svg
                v-else-if="badge === 'approved'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="shrink-0"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <svg
                v-else-if="badge === 'rejected'"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="shrink-0"
              >
                <line
                  x1="18"
                  y1="6"
                  x2="6"
                  y2="18"
                />
                <line
                  x1="6"
                  y1="6"
                  x2="18"
                  y2="18"
                />
              </svg>
            </div>
          </div>
        </template>

        <!-- Aksi -->
        <template #cell(action)="data">
          <BButton
            variant="link"
            size="sm"
            class="btn-icon rounded-lg border shadow"
            @click="$emit('action', data.item)"
          >
            <span class="k-arrow-right-3 text-[16px] text-black" />
          </BButton>
        </template>
      </BTable>

      <div
        v-if="loadingMore"
        class="text-center py-2 text-xs text-muted flex items-center justify-center gap-2"
      >
        <BSpinner
          small
          variant="primary"
        />
        <span>Memuat data...</span>
      </div>
    </div>
  </BOverlay>
</template>

<style scoped>
::v-deep .zero-padding-td-b-table td {
  padding: 0 !important;
}

::v-deep .bordered-body-b-table tbody {
  box-shadow:
    inset 0 -1px 0 #ddd,
    inset 1px 0 0 #ddd,
    inset -1px 0 0 #ddd;
  border-radius: 0 0 15px 15px;
}
</style>

<script>
import { BSpinner } from 'bootstrap-vue'
import { tableOvertimeFields } from './config'

export default {
  name: 'OvertimeTable',
  components: {
    BSpinner,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: tableOvertimeFields,
    }
  },
  methods: {
    handleScroll(event) {
      this.$emit('scroll', event)
    },
    badgeClasses(badge) {
      if (badge === 'pending') {
        return 'bg-[#FFD19A] text-[#CC4E00]'
      }
      if (badge === 'approved') {
        return 'bg-[#ADDDC0] text-[#30A46C]'
      }
      if (badge === 'rejected') {
        return 'bg-[#F4A9AA] text-[#DC2626]'
      }
      return 'bg-gray-100 text-gray-500'
    },
  },
}
</script>
